// extracted by mini-css-extract-plugin
module.exports = {"component":"ButtonItem_component_1WN_h","errorLabel":"ButtonItem_errorLabel_3nrF4"};